module.exports = __webpack_public_path__ + "static/media/volkswagen-go-drive.120bc6f4.png";